const AngularInstruction = () => {
  return (
    <div className="instructions">
 <p>1. Copy the provided code and paste it into the component's HTML file where you want it to be displayed.</p>
    </div>
  )
}

export default AngularInstruction
